// extracted by mini-css-extract-plugin
export var base = "_19-0";
export var updateBanner = "_19-1";